export default "#\n\nThe Grade Submission System is now closed for the June 2021 series.\n";